<template>
    <div class="fw-login">
        <div class="login-tb">
            <img src="../../assets/loginbt.png" class="lbt-sp"/>
        </div>
        <div class="login-cmn">
            <div class="login-content">
                <div style="display:flex;flex-direction: column;width: 75%;margin: auto">
                    <div class="mendianname">
                       <span class="mendianbt">
                           <i class="el-icon-s-shop" style="font-size: 0.42667rem;"></i>
                           <span style="margin-left: 4px;">类型</span>
                       </span>
                        <el-select v-model="loginType" placeholder="请选择账号类型" size="small">
                            <el-option
                                    v-for="item in loginTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <van-cell-group style="width: 100%;margin-bottom: 32px" :border="false">
                        <van-field
                                v-model="username"
                                left-icon="manager"
                                label="账号"
                                label-width="45px"
                                placeholder="请输入用户名/手机号"
                        />
                    </van-cell-group>
                    <van-cell-group style="width: 100%;" :border="false">
                        <van-field
                                v-model="password"
                                left-icon="lock"
                                type="password"
                                label="密码"
                                label-width="45px"
                                placeholder="请输入登录密码"
                        />
                    </van-cell-group>
                </div>
            </div>
            <div style="text-align: center;width: 75%;margin: auto;">
                <van-button type="primary" style="width: 100%;" @click="login">登 录</van-button>
            </div>
            <div class="mendian">
                <span>{{dept.deptName}}</span>
            </div>
        </div>

        <van-popup v-model="mdShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 55%;overflow:hidden;padding-bottom: 50px">
             <span class="md-bt">
                    <span>门店列表</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="md-items" v-if="loginType!=3">
                <div>
                    <div class="md-item" v-for="md in mds">
                        <div class="fw-mduser">
                            <i class="el-icon-s-shop" style="font-size: 20px;color:#777777;margin-right: 8px"/>
                            <span style="margin-left: -50%">{{md.deptName}}</span>
                            <span class="jinruEmp" @click="jinruUser(md,loginType)">进入</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="md-items" v-if="loginType==3">
                <div>
                    <div class="md-item" v-for="md in mds">
                        <div class="fw-mdemp">
                            <i class="el-icon-s-shop" style="font-size: 20px;color:#777777;margin-right: 8px"/>
                            <span>{{md.deptName}}</span>
                        </div>
                        <div class="fw-roles">
                            <div class="fw-role" v-if="md.firstLevel">
                                <span>{{md.firstStationName}} / {{md.firstLevelName}}</span>
                                <span class="jinruEmp" @click="jinruEmp(md,1)">进入</span>
                            </div>
                            <div class="fw-role" v-if="md.secondLevel">
                                <span>{{md.secondStationName}} / {{md.secondLevelName}}</span>
                                <span class="jinruEmp" @click="jinruEmp(md,2)">进入</span>
                            </div>
                            <div class="fw-role" v-if="md.thirdLevel">
                                <span>{{md.thirdStationName}} / {{md.thirdLevelName}}</span>
                                <span class="jinruEmp" @click="jinruEmp(md,3)">进入</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </van-popup>
    </div>
</template>

<script>
    import {setCookie} from './../../utils/auth'

    export default {
        data() {
            return {
                loginType: 2,
                dept: {},
                empusername: '',
                username: '',
                password: '',
                deptName: '',
                loginTypes: [
                    {'label': '总部账号', 'value': 1},
                    {'label': '门店账号', 'value': 2},
                    {'label': '员工账号', 'value': 3},
                ],
                mdShow: false,
                mds: [],
            };
        },
        async created() {
            document.title = "数字智慧助手"
        },
        methods: {
            async jinruEmp(emp, station) {
                emp.station = station
                let res = await this.$post("/fw/fwSetEmp", emp)
                if (res.code == 200) {
                    setCookie('fwUser', JSON.stringify(res.fwUser),30)
                    this.toHome()
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            async jinruUser(item, loginType) {
                item.userType = loginType
                delete item.createTime
                delete item.lastPwdResetTime
                delete item.expireTime
                let res = await this.$post("/fw/fwSetUser", item)
                if (res.code == 200) {
                    setCookie('fwUser', JSON.stringify(res.fwUser),30)
                    this.toHome()
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            async login() {
                if (this.mds && this.mds.length > 0 && this.empusername == this.username && this.emploginType == this.loginType) {
                    this.mdShow = true
                    return;
                }
                if (this.loginType == '') {
                    return this.$notify({type: 'danger', message: '请选择账号类型'});
                }
                if (this.username == '') {
                    return this.$notify({type: 'danger', message: '登录账号不能为空'});
                }
                if (this.password == '') {
                    return this.$notify({type: 'danger', message: '登录密码不能为空'});
                }
                this.empusername = this.username
                this.emploginType = this.loginType
                let data = {
                    loginType: this.loginType,
                    loginName: this.username,
                    password: this.password,
                }
                let res = await this.$post("/fw/fwLogin", data)
                if (res.code == 200) {
                    if (res.status == '1') {
                        setCookie('fwUser', JSON.stringify(res.fwUser),30)
                      this.toHome()
                    } else {
                        this.mdShow = true
                        this.mds = res.list
                    }
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            toHome(){
                this.$router.push('/home')
            },
            guanbi() {
                this.mdShow = false
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-login {
        margin: 0 auto;
        height: 100%;
        background: url(../../assets/login.jpg);
        background-size: 100% 100%;
        position: relative;
    }

    .login-tb {
        height: 30%;
        padding-top: 30%;
    }

    .lbt-sp {
        width: 60%;
        margin: auto;
        font-size: 26px;
        display: block;
        text-align: center
    }

    .login-cmn {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .login-content {
        padding-top: 25px;
        padding-bottom: 25px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .van-button {
        height: 32px;
        border-radius: 35px;
    }

    .van-button--primary {
        color: #fff;
        background-color: #FA7298;
        border: 1px solid #FA7298;
        height: 38px;
    }

    .mendian {
        width: 200px;
        text-align: center;
        font-size: 20px;
        margin-top: 50px;
        position: absolute;
        left: 50%;
        margin-left: -100px;
    }

    .van-cell-group {
        background-color: #fff;
        margin-bottom: 10px;
    }

    .van-cell {
        position: relative;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 8px 12px;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.64rem;
        background-color: #fff;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff !important;
        border-radius: 0px;
    }

    .mendianname {
        display: flex;
        flex-direction: row;
        height: 39px;
        line-height: 39px;
        background-color: #ffffff;
        margin-bottom: 32px
    }

    .mendianbt {
        font-size: 14px;
        padding: 0px 10px 0px 12px;
        height: 39px;
        line-height: 39px;
    }

    .md-items {
        display: flex;
        flex-direction: column;
        overflow: auto;
        height: 100%;
        padding-bottom: 30px;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .md-item {
        width: 90%;
        margin: auto;
        padding: 8px 20px;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        background-color: #eeeeee;
        margin-top: 10px;
        border-radius: 3px;
    }

    .fw-mduser {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .fw-mdemp {
        display: flex;
        align-items: center;
        padding-bottom: 3px;
        border-bottom: #dddddd solid 1px;
    }

    .fw-roles {
        display: flex;
        flex-direction: column;
        padding-top: 8px;
    }

    .fw-role {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 20px;
        margin: 3px 0px;
    }

    .jinruEmp {
        padding: 3px 8px;
        background-color: #2b94ff;
        border-radius: 3px;
        color: #ffffff;
    }

</style>
